/** Manually curated public blog / insight entries until a CMS or API exists. */
import { APPLYING_FOR_JOBS_VIDEO_ID, JOBUWIN_INTRO_VIDEO_ID } from "../lib/youtubeVideos";

export const PUBLIC_BLOG_POSTS = [
  {
    type: "Video",
    title: "Introducing JOBUWIN: A more human way of hiring",
    copy: "Why hiring lost its humanity — and how JOBUWIN helps genuine people and genuine companies connect again.",
    href: "/blog/introducing-jobuwin",
    previewVideoId: JOBUWIN_INTRO_VIDEO_ID,
    previewAlt: "Introducing JOBUWIN video preview",
    publishedDate: "2026-05-20",
  },
  {
    type: "Article",
    title: "Hiring is broken: Understand the real problem, not the symptoms",
    copy: "How AI-generated CVs flooded hiring with perfect fiction — and why we need more truth, not more noise.",
    href: "/blog/hiring-is-broken",
    previewImage: "/blog/hiring-is-broken-hero.png",
    previewAlt: "Zebras huddling together in a grassy savannah",
    publishedDate: "2026-05-25",
    ogImagePath: "/blog/hiring-is-broken-hero.png",
  },
  {
    type: "Video",
    title: "Applying for jobs is broken: How AI created a hiring mess",
    copy: "Why AI mass applications and automated filtering left both sides exhausted — and what human hiring should look like.",
    href: "/blog/applying-for-jobs-is-broken",
    previewVideoId: APPLYING_FOR_JOBS_VIDEO_ID,
    previewAlt: "Applying for jobs is broken video preview",
    publishedDate: "2026-05-28",
  },
];

export function getPublicBlogPostByPath(path) {
  const normalized = String(path || "").split("?")[0].replace(/\/+$/, "") || "/";
  return PUBLIC_BLOG_POSTS.find((post) => post.href === normalized) || null;
}
